
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import LogisticsSelect from '../components/select.vue';
	import Message from '@/components/message.vue';
	import CollapseItem from '@/components/collapse.vue';
  
	import {
		imgHost,
		maxspecifications
	} from '@/utils/config';
  import {
    freightSettlementTemplatefreightSettlementTemplateInfo,
    freightSettlementTemplatefreightSettlementTemplateList,
    productproductChangeFreightSettlementTemplate,
    freightSettlementTemplatefreightSettlementTemplateSave,
    freightSettlementTemplatefreightSettlementTemplateRecord
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
			LogisticsSelect,
			'slz-message': Message,
      CollapseItem,
    }
  })

  export default class ProductList extends Vue {
    private shop = {
      Name:decodeURIComponent((this as any).$route.query.Name),
      Img:decodeURIComponent((this as any).$route.query.Img),
    }
		private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private loading = false
    private form:any = {
      Id:'',
      TemplateName:'',
      FreightSettlementType:1,
      DetailList:[],
      UseProductList:[],
      ProductInfo:{}
    }
    private modelist:any = []
    private changemsg:any = {}
    private changeType = 0
    private isShowDialog = false
    private selectArea:any = []
    private disableDate:any = []
    private orderSaveTips = false
    private areatype = 1
    private ispush = false
    private showList = false
    private tableloading = false
    private routuanPrice = ''
    private totalSku:any = []
    private ProductInfo:any = {}
    private skuName = []
    private specificationsNum = maxspecifications
    private shoplist:any = []
    private lastStep:any = {
      Id:'',
      ispush:false,
      changeType:0
    }
    private showLast = false

    private errorTipsShow = false
    private errorType = 40000001


    private mounted () {
      this.getDate()
      this.getlist()
      this.gettemplatelist()
    }


    private returnLast(){
      this.form.Id = this.lastStep.Id
      this.ispush = this.lastStep.ispush
      this.changeType = this.lastStep.changeType
      this.form = {
        Id:'',
        TemplateName:'',
        FreightSettlementType:1,
        DetailList:[],
        UseProductList:[],
        ProductInfo:{}
      }
    }
    private changAllPricd2(e,type,v,i){
      let two = /^\d+(\.\d{1,2})?$/
      let routuanPrice = this.totalSku[i].RouTuanPrice
      if(Number(routuanPrice)<0.01||Number(routuanPrice)>999999.99||!two.test(routuanPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.totalSku[i].RouTuanPrice = ''
        return
      }
      this.ProductInfo.ProductMixList = this.ProductInfo.ProductMixList.map((v,index)=>{
        if(index==i){
          v.ProductSpecList = v.ProductSpecList.map(x=>{
            x.RouTuanPrice = this.totalSku[i].RouTuanPrice
            return x
          })
        }
        return v
      })
    }
    private changAllPricd(e,type,v,i){
      let two = /^\d+(\.\d{1,2})?$/
      let routuanPrice = this.totalSku[i].RouTuanPrice
      if(Number(routuanPrice)<0.01||Number(routuanPrice)>999999.99||!two.test(routuanPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.totalSku[i].RouTuanPrice = ''
        return
      }
      this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map((v,index)=>{
        if(i==index){
          v = v.map(x=>{
            x.RouTuanPrice = this.totalSku[i].RouTuanPrice
            return x
          })
        }
        return v
      })
    }
    private setRoutuanPrice(){
      if(!this.routuanPrice){
        return
      }
      let two = /^\d+(\.\d{1,2})?$/
      let routuanPrice = Number(this.routuanPrice)
      if(routuanPrice<0.01||routuanPrice>999999.99||!two.test(this.routuanPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.routuanPrice = ''
        return
      }
      if(this.ProductInfo.ProductType==0){
        if(!this.ProductInfo.IsIncludedSubmitOrderInfo){
          this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map(v=>{
            v.RouTuanPrice = this.routuanPrice
            return v
          })
        }else{
          this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map(v=>{
            v = v.map(x=>{
              x.RouTuanPrice = this.routuanPrice
              return x
            })
            return v
          })
        }
      }else{
        this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map((v,index)=>{
          v.RouTuanPrice = this.routuanPrice
          return v
        })
      }
    }
    private getskuName(){
      this.skuName = []
      for(let i = 0;i<this.specificationsNum;i++){
        let key = 'SpecTitle'+(i==0?'':i+1)
        if(this.ProductInfo[key]){
          this.skuName.push({
            sku_name: this.ProductInfo[key],
            sku_info: [],
            key:Math.random(),
            Sort:i+1,
          })
        }
      }
      this.ProductInfo.ProductSpecList.map(item=>{
        for(let i = 0;i<this.specificationsNum;i++){
          let key = 'SpecValue'+(i==0?'':i+1)
          if(item[key] && this.skuName[i]){
            var have = null;
            this.skuName[i].sku_info.map((obj: any, index: number) => {
              if (obj.sku_value === item[key]) {
                have = obj;
              }
            })
            if (!have) {
              let data = {
                sku_value: item[key],
              }
              this.skuName[i].sku_info.push(data)
            }
          }
        }
      })
      // console.log(this.ProductInfo,this.skuName)
    }
    private getShoplist(){
      if(this.ProductInfo.ProductType==0&&this.ProductInfo.IsIncludedSubmitOrderInfo){
        let list = this.getshardlist(this.ProductInfo.ProductSpecList)
        this.totalSku = list.map(v=>{
          return {
            RouTuanPrice:''
          }
        })
        this.ProductInfo.ProductSpecList = list
      }else if(this.ProductInfo.ProductType==1){
        this.ProductInfo.ProductMixList.sort((a,b)=>{
          return b.ProductId - a.ProductId
        })
        let list = this.getassemblylist(this.ProductInfo.ProductMixList)
        this.totalSku = list.map(v=>{
          return {
            RouTuanPrice:''
          }
        })
        // console.log(list)
        this.ProductInfo.ProductMixList = list
        this.routuanPrice = this.ProductInfo.ProductSpecList[0].RouTuanPrice
      }
    }
    private getshardlist(list:any){
      let sku = JSON.parse(JSON.stringify(this.skuName))
			let newlist:any = []
			sku[0].sku_info.map((v,i)=>{
				let data:any = []
				list.map(x=>{
					if(x.SpecValue==v.sku_value){
						data.push(x)
					}
				})
				newlist.push(data)
			})
			return newlist
    }
    private getassemblylist(list:any){
      return list.map((v,i)=>{
        v.skuName = []
        for(let i = 0;i<this.specificationsNum;i++){
          let key = 'SpecTitle'+(i==0?'':i+1)
          if(v[key]){
            v.skuName.push({
              sku_name: v[key],
              sku_info: [],
              key:Math.random(),
              Sort:i+1,
            })
          }
        }
        v.ProductSpecList.map(item=>{
          for(let i = 0;i<this.specificationsNum;i++){
            let key = 'SpecValue'+(i==0?'':i+1)
            if(item[key] && v.skuName[i]){
              var have = null;
              v.skuName[i].sku_info.map((obj: any, index: number) => {
                if (obj.sku_value === item[key]) {
                  have = obj;
                }
              })
              if (!have) {
                let data = {
                  sku_value: item[key],
                }
                v.skuName[i].sku_info.push(data)
              }
            }
          }
        })
        return v
      })
    }
    private recover(){
      this.form = {
        Id:'',
        TemplateName:'',
        FreightSettlementType:1,
        DetailList:[],
        UseProductList:[],
      }
    }
    private confirm(){
      if(this.changeType==1){
        this.changesave()
      }else{
        this.confirmsave()
      }
    }
    private async getlist(){
      try{
        let res = await freightSettlementTemplatefreightSettlementTemplateRecord({
          ProductId:this.$route.query.Id
        })
        if(res.IsSuccess){
          let list = res.Result
          // console.log(list)
          this.showList = list&&list.length>1
        }
      }finally{
        //
      }
    }
    private async changesave(){
      try{
        this.loading = true
        let res = await productproductChangeFreightSettlementTemplate({
          ProductId:this.$route.query.Id,
          FreightSettlementTemplateId:this.form.Id,
          ProductInfo:this.getProductInfo()
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.cancel()
        }
      }finally{
        this.loading = false
      }
    }
    private changeTemplate(e){
      if(this.changeType==0){
        this.showLast = true
      }
      let template = this.modelist.find(v=>v.Id==e)
      this.form = {
        ...this.form,
        Id:template.Id,
        TemplateName:template.TemplateName,
        FreightSettlementType:template.FreightSettlementType,
        DetailList:template.DetailList
      }
      this.changeType = 1
      this.getshop(e)
    }
    private async getshop(id){
      try{
        this.tableloading = true
        let res = await freightSettlementTemplatefreightSettlementTemplateInfo({
          Id:await id
        })
        if(res.IsSuccess){
          // console.log(res.Result)
          this.form.DetailList = res.Result.DetailList
          this.form.UseProductList = res.Result.UseProductList
        }
      }finally{
        this.tableloading = false
      }
    }
    private async getDate(){
      try{
        this.loading = true
        let res = await freightSettlementTemplatefreightSettlementTemplateInfo({
          // Id:this.form.Id||'',
          ProductId:this.$route.query.Id
        })
        if(res.IsSuccess){
          if(res.Result.Id){
            this.form = res.Result
          }
          this.ProductInfo = res.Result.ProductInfo
          this.getskuName()
          this.getShoplist()
        }
      }finally{
        this.loading = false
      }
    }
    private async gettemplatelist(){
      try{
        let res = await freightSettlementTemplatefreightSettlementTemplateList({
          ProviderId:'',
          ProductId:'',
          Keywords:'',
          StartTime:'',
          EndTime:'',
        })
        if(res.IsSuccess){
          this.modelist = res.Result
          // console.log(this.modelist)
        }
      }finally{
        //
      }
    }
    private toRecord(){
      this.$router.push({
        path:'settleFreightRecord',
        query:this.$route.query
      })
    }
    private delrow(e){
      this.form.DetailList.splice(e,1)
    }
    private selectConfirm(e){
      if(!e.list||!e.list.length){
        this.$message.error('请选择配送区域')
        this.isShowDialog  =true
        return
      }
      if(this.areatype<0){
        this.form.DetailList.push({
          AreaNames:e.list.map(v=>{
            return v.join('-')
          }),
          Id:0,
          FirstCountToNumber:'',
          FirstMoneyToNumber:'',
          ContinueCountToNumber:'',
          ContinueMoneyToNumber:'',
        })
      }else{
        this.form.DetailList[this.areatype].AreaNames = e.list.map(v=>{
          return v.join('-')
        })
      }
    }
    private pushDispensingArea(type,row?:any){
      this.areatype = type
      if(row.AreaNames&&row.AreaNames.length){
        this.selectArea = JSON.parse(JSON.stringify(row.AreaNames.map(x=>{
          return x.split('-')
        })))
      }else{
        this.selectArea = []
      }
      this.disableDate = JSON.parse(JSON.stringify(this.form.DetailList)).map(v=>{
        return v.AreaNames.map(x=>{
          return x.split('-')
        })
      }).flat().filter(v=>{
        let ishave = this.selectArea.some(m=>{
          let v0 = v[0]&&m[0]==v[0]
          let v1 = true
          if(v[1]){
            v1 = m[1]&&m[1]==v[1]
          }
          return v0&&v1
        })
        return !ishave
      })
      this.isShowDialog = true
    }
    private save(){
      if(!this.test()) return
      this.orderSaveTips = true
    }
    private test(){
      let two = /^\d+(\.\d{1,2})?$/
      let form = JSON.parse(JSON.stringify(this.form))
      let ProductInfo = JSON.parse(JSON.stringify(this.ProductInfo))
      //单品
      if(ProductInfo.ProductType==0){
        //不计入交单
        if(!this.ProductInfo.IsIncludedSubmitOrderInfo){
          for(let item of ProductInfo.ProductSpecList){
            if(Number(item.RouTuanPrice)<0.01||Number(item.RouTuanPrice)>999999.99||!two.test(item.RouTuanPrice)){
              this.$message.error('请输入正确的供货价')
              return false
            }
          }
        }else{
          for(let item of ProductInfo.ProductSpecList){
            for(let item2 of item){
              if(Number(item2.RouTuanPrice)<0.01||Number(item2.RouTuanPrice)>999999.99||!two.test(item2.RouTuanPrice)){
                this.$message.error('请输入正确的供货价')
                return false
              }
            }
          }
        }
      }else{
        //以组合商品下单
        if(ProductInfo.SettlementType==0){
          if(!this.routuanPrice){
            this.$message.error('请输入供货价')
            return false
          }
          for(let item of ProductInfo.ProductSpecList){
            if(Number(item.RouTuanPrice)<0.01||Number(item.RouTuanPrice)>999999.99||!two.test(item.RouTuanPrice)){
              this.$message.error('请输入正确的供货价')
              return false
            }
          }
        }else{
          for(let item of ProductInfo.ProductMixList){
            for(let item2 of item.ProductSpecList){
              if(Number(item2.RouTuanPrice)<0.01||Number(item2.RouTuanPrice)>999999.99||!two.test(item2.RouTuanPrice)){
                this.$message.error('请输入正确的供货价')
                return false
              }
            }
          }
        }
      }
      
      if(!form.TemplateName){
        this.$message.error('请输入模板名称')
        return false
      }
      if(!form.DetailList||!form.DetailList.length){
        this.$message.error('请设置区域运费规则')
        return false
      }
      for(let item of form.DetailList){
        if(form.FreightSettlementType==1){
          if(!item.FirstCountToNumber&&String(item.FirstCountToNumber)!=='0'
          ||!item.ContinueMoneyToNumber&&String(item.ContinueMoneyToNumber)!=='0'
          ||!item.ContinueCountToNumber&&String(item.ContinueCountToNumber)!=='0'
          ||!item.FirstMoneyToNumber&&String(item.FirstMoneyToNumber)!=='0'){
            this.$message.error('物流价格或件数不能为空')
            return false
          }
          if(
            item.ContinueMoneyToNumber<0||item.ContinueMoneyToNumber>1000000||!two.test(item.ContinueMoneyToNumber)||
            item.FirstMoneyToNumber<0||item.FirstMoneyToNumber>1000000||!two.test(item.FirstMoneyToNumber)
            )
            {
              this.$message.error('运费金额最大支持1000000')
              return false
            }
        }else{
          if(!item.FirstMoneyToNumber&&String(item.FirstMoneyToNumber)!=='0'){
            this.$message.error('请完善区域运费规则')
            return false
          }
          if(item.FirstMoneyToNumber<0||item.FirstMoneyToNumber>1000000||!two.test(item.FirstMoneyToNumber)){
            this.$message.error('运费金额最大支持1000000')
            return false
          }
        }
      }

      return true
    }
    private getProductInfo(){
      let ProductInfo = JSON.parse(JSON.stringify(this.ProductInfo))
      if(ProductInfo.ProductType==0&&ProductInfo.IsIncludedSubmitOrderInfo){
        let list = []
        ProductInfo.ProductSpecList.map(v=>{
          v.map(x=>{
            list.push(x)
          })
        })
        ProductInfo.ProductSpecList = list
      }
      return ProductInfo
    }
    private async confirmsave(){
      try{
        this.loading = true
        
        let res = await freightSettlementTemplatefreightSettlementTemplateSave({
          ...this.form,
          ProductId:this.$route.query.Id,
          UseProductList:undefined,
          ProductInfo:this.getProductInfo(),
          noError:true
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')

          this.cancel()
        }else{
					if(res.ErrorCode==40000001||res.ErrorCode==40000002){
						this.errorTipsShow = true
						this.errorType = res.ErrorCode
					}else{
						this.$message.error(res.Message)
					}
				}
      }finally{
        this.loading = false
      }
    }
    private cancel(){
      this.changeType = 0
      this.ispush = false
      this.recover()
      this.getDate()
    }
    private changeModeType(num){
      if(this.changeType!=0) return
      this.showLast = false
      this.changeType = num
      if(num==1){
        this.gettemplatelist()
      }
    }
  }
